<template>
  <div class="swiper-wrapper">
    <!--热门推荐
      1 临床好课  2图文资讯  4 直播（单/专栏：单场直播预告/回放/直播中） 6 病例实战  13 专题
      14 会议微网站 30 医学专栏
       -->
    <div v-for="(item, index) in dataItem" :key="index" class="swiper-slide column-section-swiper">
      <course v-if="item.origin_type === 1" :dataItem="item" />
      <hArticle v-else-if="item.origin_type === 2" :dataItem="item" />
      <lives v-else-if="item.origin_type === 4" :dataItem="item" />
      <hCase v-else-if="item.origin_type === 6" :dataItem="item" />
      <special v-else-if="item.origin_type === 13" :dataItem="item" />
      <academic v-else-if="item.origin_type === 14" :dataItem="item" />
      <medicine v-else-if="item.origin_type === 30" :dataItem="item" />
    </div>
  </div>
</template>

<script>
import lives from './lives'
import course from './course'
import hArticle from './article'
import hCase from './case'
import medicine from './medicine'
import special from './special'
import academic from "./academic";
export default {
  name: "index",
  components: {
    lives,
    course,
    hArticle,
    hCase,
    medicine,
    special,
    academic
  },
  props: {
    dataItem: {
      type: Array,
      required: true
    }
  },
}
</script>

<style scoped lang="scss">
.lives-section-swiper{
  .van-image{
    border-radius: 6px;
    /deep/ .van-image__img{
      border-radius: 6px;
    }
  }
  .lives-section-content-title{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
    line-height: 20px;
    margin-top: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .lives-section-content-detail{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    margin-top: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/horizontalRecommend/index.vue